define('app/visualizations/VisualizationView',['require','glu/itemView','app/visualizations/ValidationView'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		ValidationView = require('app/visualizations/ValidationView');

	return ItemView.extend({


		constructor: function() {
			ItemView.apply(this, arguments);
			this.listenTo(this.model, 'dataReceived', this.render);
			return this;
		},

		render: function() {

			if (!this.model.results()) {
				return this;
			}

			this.data = this.model.consumableResults();

			if (this.canRenderReport()) {
				this.renderVisualization();
			} else {
				this.renderIncompatibleMessage();
			}
			this.model.trigger('graphRendered');
			return this;
		},

		canRenderReport: function() {
			return this.model.canRenderReport();
		},

		renderVisualization: function() {
			return ItemView.prototype.render.apply(this, arguments);
		},

		renderIncompatibleMessage: function() {
			var validationView = new ValidationView({
				model: this.model
			});

			this.$el.html(validationView.render().el);
		}
	});
});

